import React from 'react';

import { Flex, FlexItem, Button } from '@wordpress/components';

const PaymentDetails = (props) => {
  //   console.log('Payment Details card:', props.card);
  const cardDigitsReplacement = ' •••• •••• •••• ';
  const capitalize = (s) => {
    if (typeof s !== 'string') return '';
    const res = s.replace('card', 'Card');
    return res.charAt(0).toUpperCase() + res.slice(1);
  };
  return (
    <>
      <Flex className='section-title'>Your payment method</Flex>
      <Flex className='section-row'>
        <FlexItem>
          {(props.card && props.card.brand
            ? capitalize(props.card.brand)
            : '') +
            cardDigitsReplacement +
            (props.card && props.card.last4 ? props.card.last4 : '••••') +
            (props.card && props.card.holderName
              ? ' ' + props.card.holderName
              : '')}
        </FlexItem>
        <FlexItem>
          <Button isLink onClick={() => props.changeFunction()}>
            {props.card && Object.keys(props.card).length > 0
              ? 'Change'
              : 'Add Card'}
          </Button>
        </FlexItem>
      </Flex>
    </>
  );
};

export default PaymentDetails;
